<template>
  <div>
    <RevDrawer
      :has-back-button
      :name="MODAL_NAMES.TECH_SPECS"
      :title="i18n(translations.title)"
      @back="onBack"
    >
      <template #body>
        <div class="pb-56">
          <h3 v-if="technicalSpecifications.title" class="heading-2 mx-auto">
            {{ technicalSpecifications.title }}
          </h3>

          <div v-if="showSpecifications" class="mt-32" data-test="specs">
            <div class="mb-4 mt-8">
              <RevInputText
                id="tech-spec-search"
                v-model="valueFilter"
                autocomplete="off"
                autocorrect="off"
                :icon="IconSearch"
                :label="i18n(translations.search)"
                name="tech-spec-search"
                type="search"
              />
            </div>
            <RevList class="mt-16" :has-external-borders="false">
              <RevListItemStatic
                v-for="(spec, index) in specifications"
                :key="`${spec.display}-${index}`"
              >
                <template #label>
                  <p class="body-1">
                    {{ spec.display }}
                  </p>
                </template>
                <template #suffix>
                  <span
                    v-for="value in spec.values"
                    :key="value.label"
                    class="body-2 whitespace-break-spaces"
                  >
                    {{ value.label }}
                  </span>
                </template>
              </RevListItemStatic>
            </RevList>
          </div>

          <div v-if="showAdditionalInfo" class="mt-24">
            <p v-for="info in additionalInfo" :key="info" class="body-2">
              {{ info }}
            </p>
          </div>
        </div>
      </template>
    </RevDrawer>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import type { GetTechnicalSpecificationsResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/technical-specifications'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevDrawer } from '@ds/components/Drawer'
import { RevInputText } from '@ds/components/InputText'
import { RevList } from '@ds/components/List'
import { RevListItemStatic } from '@ds/components/ListItemStatic'
import { IconSearch } from '@ds/icons/IconSearch'

import { searchObjects } from '../../utils/SearchObjects'
import { MODAL_NAMES } from '../constants'

import translations from './TechSpecModal.translations'

const props = withDefaults(
  defineProps<{
    technicalSpecifications: GetTechnicalSpecificationsResponse
    hasBackButton?: boolean
    onBack?: () => void
  }>(),
  {
    hasBackButton: false,
    onBack: undefined,
  },
)

const i18n = useI18n()
const valueFilter = ref('')

const showSpecifications = computed(() => {
  return !isEmpty(props.technicalSpecifications.specifications)
})
const specifications = computed(() => {
  return searchObjects(
    props.technicalSpecifications.specifications,
    'display',
    valueFilter.value,
  )
})
const showAdditionalInfo = computed(() => {
  return !isEmpty(props.technicalSpecifications.additionalInfo)
})
const additionalInfo = computed(() => {
  return props.technicalSpecifications.additionalInfo
})
</script>
